module.exports = __webpack_public_path__ + "img/pinturas_recubrimientos.621d8dce.jpg";